import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon/Icon';
import Button from './bootstrap/Button';

const CollapsibleSection = ({ title, collapsibleSectionBool, toggleCollapsibleSection }) => {
	return (
		<div className='flex-row d-flex align-items-center' style={{ marginBottom: '0.75rem' }}>
			<Button
				style={{
					marginRight: '10px',
					padding: 0,
					borderWidth: 0,
				}}
				onClick={() => toggleCollapsibleSection(!collapsibleSectionBool)}>
				<Icon
					icon={collapsibleSectionBool ? 'ChevronDown' : 'ChevronUp'}
					style={{
						height: '12px',
						width: '12px',
					}}
				/>
			</Button>
			<div
				style={{
					fontSize: 'small',
				}}>
				<b>{title}</b>
			</div>
			
		</div>
	);
};

CollapsibleSection.propTypes = {
	title: PropTypes.string.isRequired,
	collapsibleSectionBool: PropTypes.bool.isRequired,
	toggleCollapsibleSection: PropTypes.func.isRequired,
};
CollapsibleSection.defaultProps = {};

export default CollapsibleSection;
